import React from 'react';
import LegalPage from '../components/marketing/LegalPage';
import { LEGAL_PAGES } from '../data/legalContent';

export default function RefundCancellationPolicyPage() {
  return <LegalPage content={LEGAL_PAGES.refund} />;
}
